<template>
  <div class="login-page">
      <h1>ورود پسورد</h1>
      <input v-model="password" placeholder="password v140007" @keyup="checkPassword" >
      <p>{{msg}}</p>
  </div>
</template>

<script>
// @ is an alias to /src

var Lockr = require("lockr");
export default {
  name: 'LoginPage',
  components: {
    
  },
  data(){
      return {password:"",msg:"پسورد اشتباه است."}
  },
  mounted(){
      this.password = Lockr.get("pajn39jad", "");
    if(this.password=="121" || this.password==121){
              this.msg="پسورد صحیح می باشد... لطفا صفحه را دوباره بارگزاری کنید.";
          }
  },
  methods:{
      checkPassword(){
             Lockr.set("pajn39jad", this.password);
        //   Lockr.get("pajn39jad", 1) == this.password;//"121";
          if(this.password=="121" || this.password==121){
              this.msg="پسورد صحیح می باشد... لطفا صفحه را دوباره بارگزاری کنید.";
          }else{
              this.msg="پسورد اشتباه است.";
          }
      }
  }
}
</script>
